<template>
  <div>
    <div style="font-size: 0.5rem; height: 1.3rem; display: flex; align-items: center; justify-content: center; font-weight: 700; color: #cf866b">
      {{ $store.state.appInfo.title }}app下载
    </div>

    <img style="width: 100%; margin-top: 20px" src="/static/image/sports_and_2_title-eb044a43aca57221f5bdc248cbb1356d.png" alt="应用标题图" />

    <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
      <van-swipe-item><img style="width: 100%" src="/static/image/sports_8.png" alt="应用截图1" /></van-swipe-item>
      <van-swipe-item><img style="width: 100%" src="/static/image/sports_71.png" alt="应用截图2" /></van-swipe-item>
      <van-swipe-item><img style="width: 100%" src="/static/image/sports_aa.png" alt="应用截图3" /></van-swipe-item>
      <van-swipe-item><img style="width: 100%" src="/static/image/sports_and4.png" alt="应用截图4" /></van-swipe-item>
    </van-swipe>
    
    <img style="width: 100%; margin-top: 20px" src="/static/image/sports_and_1_icon-c53b51a31998cee56a723ab1dcaa4f91.png" alt="应用图标" />
    
    <div style="width: 90%; margin: 0 auto; color: #ccc; text-align: center; margin-top: 20px">
      可扫描下方二维码进行app下载
    </div>

    <img style="width: 70%; margin: 0 auto; display: block" :src="$store.state.appInfo.ios_download_qrcode" alt="下载二维码" />

    <van-button style="width: 90%; margin: 0 auto; margin-top: 30px; display: block" type="info" @click="handleDownload">
      立即下载
    </van-button>
    
    <div style="width: 90%; margin: 10px auto; color: #ccc">
      需在同一网络环境下下载安装注册，请勿切换网络； 若无法正常安装，请使用手机自带浏览器打开本页面
    </div>
    
    <div style="height: 100px"></div>
  </div>
</template>

<script>
export default {
  name: 'app',
  data() {
    return {};
  },
  created() {
    console.log(this.$store.state.appInfo);
  },
  methods: {
    // 判断设备类型
    isAndroid() {
      return /android/i.test(navigator.userAgent);
    },
    isIOS() {
      return /iphone|ipad|ipod/i.test(navigator.userAgent);
    },
    // 下载文件 - 修改为直接跳转
    downloadUrl(url) {
      console.log('下载链接:', url);
      if (url) {
        // 直接跳转至下载链接
        window.location.href = url;
      } else {
        this.$toast('未找到有效的下载链接');
      }
    },
    // 按钮点击处理
    handleDownload() {
      const appInfo = this.$store.state.appInfo;
      if (this.isAndroid()) {
        // 安卓下载
        this.downloadUrl(appInfo.android_download_url);
      } else if (this.isIOS()) {
        // iOS 下载
        this.downloadUrl(appInfo.ios_download_url);
      } else {
        // 其他设备提示
        this.$toast('请使用安卓或 iOS 设备下载');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/mode/app.vue